import { Dispatch } from "redux";
import { ReduxStore } from "../payload-types";
import { LINKS } from "@trip-ux/constants";
import {
    CREATE_AGENT_LICENSE,
    CREATE_AGENCY_LICENSE,
    CREATE_AGENCY_LICENSE_FAILED,
    CREATE_AGENT_LICENSE_FAILED,
    CREATE_AGENT_LICENSE_START,
    CREATE_AGENCY_LICENSE_START,
    LicenseRequest,
    GET_AGENT_LICENSE_START,
    GET_AGENCY_LICENSE_START,
    GET_AGENT_LICENSE,
    GET_AGENCY_LICENSE,
    GET_AGENT_LICENSE_FAILED,
    GET_AGENCY_LICENSE_FAILED,
    UPDATE_AGENT_LICENSE_START,
    UPDATE_AGENT_LICENSE_FAILED,
    UPDATE_AGENT_LICENSE,
    UPDATE_AGENCY_LICENSE_START,
    UPDATE_AGENCY_LICENSE,
    UPDATE_AGENCY_LICENSE_FAILED,
} from './types';
import { ApiClient } from "../api.client";
export const createAgencyLicense =
    (organizationCode: string, license: LicenseRequest) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                const licensePayload = { organizationCode, license }
                dispatch({ type: CREATE_AGENCY_LICENSE_START });

                const response = await apiClient(dispatch, getState).post(LINKS.CREATE_AGENCY_LICENSE, licensePayload)
                dispatch({
                    type: CREATE_AGENCY_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: CREATE_AGENCY_LICENSE_FAILED, payload: error });
            }
        };

export const createAgentLicense =
    (profileRef: string, license: LicenseRequest) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                dispatch({ type: CREATE_AGENT_LICENSE_START });
                const licensePayload = { profileRef, license }
                const response = await apiClient(dispatch, getState).post(LINKS.CREATE_AGENT_LICENSE, licensePayload)
                dispatch({
                    type: CREATE_AGENT_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: CREATE_AGENT_LICENSE_FAILED, payload: error });
            }


        };
export const getAgentLicense =
    (profileRef: string, licenseId: number) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                dispatch({ type: GET_AGENT_LICENSE_START });
                const response = await apiClient(dispatch, getState).get(`${LINKS.AGENT_LICENSE}/${profileRef}/license/${licenseId}`)
                dispatch({
                    type: GET_AGENT_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: GET_AGENT_LICENSE_FAILED, payload: error });
            }

        };
export const getAgencyLicense =
    (org: string, licenseId: number) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                dispatch({ type: GET_AGENCY_LICENSE_START });
                const response = await apiClient(dispatch, getState).get(`${LINKS.AGENCY_LICENSE}/${org}/license/${licenseId}`)
                dispatch({
                    type: GET_AGENCY_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: GET_AGENCY_LICENSE_FAILED, payload: error });
            }

        };

export const updateAgentLicense =
    (profileRef: string, licenseId: number,license: LicenseRequest) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                dispatch({ type: UPDATE_AGENT_LICENSE_START });
                const response = await apiClient(dispatch, getState).put(`${LINKS.AGENT_LICENSE}/${profileRef}/license/${licenseId}`, license)
                dispatch({
                    type: UPDATE_AGENT_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: UPDATE_AGENT_LICENSE_FAILED, payload: error });
            }

        };
export const updateAgencyLicense =
    (org: string, licenseId: number,license: LicenseRequest ) =>
        async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
            try {
                dispatch({ type: UPDATE_AGENCY_LICENSE_START });
                const response = await apiClient(dispatch, getState).put(`${LINKS.AGENCY_LICENSE}/${org}/license/${licenseId}`, license)
                dispatch({
                    type: UPDATE_AGENCY_LICENSE,
                    payload: {
                        response
                    }
                });
            }
            catch (error) {
                dispatch({ type: UPDATE_AGENCY_LICENSE_FAILED, payload: error });
            }

        };